import { App } from 'antd';
import { createContext, useContext, useMemo, type ReactNode } from 'react';

interface ToastApi {
  success: (msg: string) => void;
  info: (msg: string) => void;
  warn: (msg: string) => void;
  error: (msg: string) => void;
}

const ToastContext = createContext<ToastApi | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const { message } = App.useApp();
  const value = useMemo<ToastApi>(
    () => ({
      success: (m) => message.success(m),
      info: (m) => message.info(m),
      warn: (m) => message.warning(m),
      error: (m) => message.error(m),
    }),
    [message],
  );
  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
}

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used inside <ToastProvider>');
  }
  return ctx;
}
